// extracted by mini-css-extract-plugin
export default {"input-label":"InputLabel_input-label__-tQG7"};